export function getNetworkColor(lineId: string) {
  let hash = 0;

  for (const char of lineId) {
    hash = char.charCodeAt(0) + ((hash << 5) - hash);
  }

  const hue = (Math.abs(hash) * 137.508) % 360;

  return `hsl(${hue}, 70%, 45%)`;
}
